import { useState } from 'react'
import type { ImgHTMLAttributes } from 'react'

type Props = {
  className?: string
  fallbackImg?: string
  alt?: string
} & ImgHTMLAttributes<HTMLImageElement>

export default function Img(props: Props) {
  const [url, setUrl] = useState(null)
  const { fallbackImg, className, src, ...rest } = props

  return (
    <img
      {...rest}
      alt={props.alt || 'image'}
      className={className}
      src={url || src}
      onError={() => {
        setUrl(fallbackImg || `${process.env.IMG_ORIGIN}/placeholder.jpg`)
      }}
    />
  )
}
